import { If, TabLink } from "components";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { Routes } from "modules/common";
import { Managers, Qrs, DamagedItems, MissingItems } from "modules/inventory";
import { Warehouses } from "modules/warehouses";
import { useParams } from "react-router-dom";

import styles from "./InventoryPage.module.scss";

const InventoryPage = () => {
  const { activeTab } = useParams();
  const inventoryRoutes = Routes.find((route) => {
    return route.label === "Inventory";
  })?.nestedRoutes;

  return (
    <ContentLayout title={t("Inventory")}>
      <BoxShadowLayout className={styles.pageContent}>
        <If condition={!!inventoryRoutes}>
          <nav>
            {inventoryRoutes?.map((route) => (
              <TabLink
                key={route.label}
                pathName={route.path}
                label={t(route.label)}
              />
            ))}
          </nav>
        </If>

        <If condition={activeTab === "managers"}>
          <Managers />
        </If>

        <If condition={activeTab === "qrs"}>
          <Qrs />
        </If>

        <If condition={activeTab === "damaged-items"}>
          <DamagedItems />
        </If>

        <If condition={activeTab === "missing-items"}>
          <MissingItems />
        </If>

        <If condition={activeTab === "warehouses"}>
          <Warehouses />
        </If>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default InventoryPage;
